import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	isNoAddressNeeded: ForNodeType<boolean>;
	onSetViewModel: (
		values: {
			key: "isNoAddressNeeded";
			value: ForNodeType<boolean>;
		}[],
	) => void;
};

export const usePlanIsNoAddressNeeded = ({ isNoAddressNeeded, onSetViewModel }: Props) => {
	const onSetIsNoAddressNeeded = (value: boolean) => {
		onSetViewModel([
			{
				key: "isNoAddressNeeded",
				value: {
					isEdited: true,
					value,
				},
			},
		]);
	};

	return {
		isNoAddressNeeded,
		onSetIsNoAddressNeeded,
	};
};
